export default "__VITE_ASSET__ca22f233__"